import { Controller } from "@hotwired/stimulus"

const CHECK_ON = "#00d6b4"
const CHECK_OFF = "rgba(255,255,255,.05)"
const CHECK_OFF_RING = "inset 0 0 0 1.5px rgba(255,255,255,.16)"
const ROW_ON = "rgba(0,214,180,.05)"

export default class extends Controller {
  static targets = ["row", "checkbox", "check", "count", "apply", "selectAll"]

  connect() {
    this.refresh()
  }

  toggle(event) {
    const index = this.rowTargets.indexOf(event.currentTarget)
    if (index < 0) return

    this.checkboxTargets[index].checked = !this.checkboxTargets[index].checked
    this.refresh()
  }

  selectAll() {
    const target = this.checkboxTargets.some((checkbox) => !checkbox.checked)
    this.checkboxTargets.forEach((checkbox) => (checkbox.checked = target))
    this.refresh()
  }

  refresh() {
    const total = this.checkboxTargets.length
    let selected = 0

    this.rowTargets.forEach((row, index) => {
      const on = this.checkboxTargets[index].checked
      if (on) selected += 1

      row.style.background = on ? ROW_ON : ""

      const check = this.checkTargets[index]
      check.style.background = on ? CHECK_ON : CHECK_OFF
      check.style.boxShadow = on ? "none" : CHECK_OFF_RING
      check.querySelector("svg").style.opacity = on ? "1" : "0"
    })

    if (this.hasCountTarget) this.countTarget.textContent = `${selected} selected`

    if (this.hasApplyTarget) {
      this.applyTarget.textContent = selected ? `Apply ${selected}` : "Apply"
      this.applyTarget.disabled = selected === 0
    }

    if (this.hasSelectAllTarget) {
      this.selectAllTarget.textContent = selected === total ? "Deselect all" : "Select all"
    }
  }
}
